import React from "react";

function RightArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 11 18" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.626389 0.292893C1.01691 -0.0976311 1.65008 -0.0976311 2.0406 0.292893L10.0406 8.29289C10.4311 8.68342 10.4311 9.31658 10.0406 9.70711L2.0406 17.7071C1.65008 18.0976 1.01691 18.0976 0.626389 17.7071C0.235865 17.3166 0.235865 16.6834 0.626389 16.2929L7.91928 9L0.626389 1.70711C0.235865 1.31658 0.235865 0.683417 0.626389 0.292893Z"
        fill="white"
      />
    </svg>
  );
}

const MemoRightArrow = React.memo(RightArrow);
export default MemoRightArrow;
